import { h } from "preact";
import { Typography, Paper, Box, Stack, } from "@mui/material";

export default function CardTemplate({ title, buttons, content, fullHeight }) {

    return (
        <Paper style={`padding: 5px; ${fullHeight && "height: 100%"}`}>
            < Stack spacing={1} >
                <Box
                    display="flex"
                    alignItems="flex-start"
                    justifyContent="space-between"
                    style="margin-bottom: 5px;"
                >
                    <Box
                        sx={{ flexGrow: 1 }}
                        p={1}
                    // style="width: 100%;" 
                    >
                        <Typography variant="h5" style="width: 100%; border-bottom: 1px solid rgb(234, 234, 234);">
                            {title}
                        </Typography>
                    </Box>
                    {buttons && <Box >
                        {buttons}
                    </Box>}
                </Box>
                <div style="padding-right: 5px; padding-left: 5px; margin-top: 0px;">
                    {content}
                </div>

            </Stack>
        </Paper>
    );
}
